
import { TDiversificacionPosiciones, TTablaDetalleDiversificacion, TTotalesTipoActivo1, TTotalesTipoActivo2 } from "../../../services/OmniaService"

export type TDataDiversificacionActivo1 = {
    name: string;
    data: TTotalesTipoActivo1
    children?: TDataDiversificacionActivo1y2[]
}

export type TDataDiversificacionActivo1y2 = {
    name: string;
    name2: string;
    data: TTotalesTipoActivo2
    children?: TDataDiversificacionPosiciones[]
}

export type TDataDiversificacionPosiciones = {
    name: string;
    name2: string;
    data: TDiversificacionPosiciones
}

export const FormatDataTableDiversificacion = (data:  TTablaDetalleDiversificacion) : TDataDiversificacionActivo1[] => {
    const dataSend: TDataDiversificacionActivo1[] = [];

    data.totales_tipoactivo1.forEach(itemLevel1 => {
        const data1: TDataDiversificacionActivo1 = {
            name: itemLevel1.tipoactivo1,
            data: itemLevel1,
            children: []
        };

        data.totales_tipoactivo2.forEach(itemLevel2 => {
            if (itemLevel2.tipoactivo1 === itemLevel1.tipoactivo1) {
                const data2: TDataDiversificacionActivo1y2 = {
                    name: itemLevel2.tipoactivo1,
                    name2: itemLevel2.tipoactivo2,
                    data: itemLevel2,
                    children: []
                };

                data.posiciones.forEach(itemLevel3 => {
                    if (itemLevel3.tipoactivo2 === itemLevel2.tipoactivo2) {
                        data2.children?.push({
                            name: itemLevel3.tipoactivo1,
                            name2: itemLevel3.tipoactivo2,
                            data: itemLevel3
                        });
                    }
                });

                data1.children?.push(data2);
            }
        });

        dataSend.push(data1);
    });

    return dataSend;
};